module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daythunderstorm@3-88931c0daa30bb22b12d979dbbc845e8.png";